import React from 'react';

interface BlueButtonProps {
  onClick: () => void;
  label?: string;
  icon?: React.ReactNode;
  inputId?: string;
  disabled?: boolean;
}

const BlueButton: React.FC<BlueButtonProps> = ({
  onClick,
  inputId,
  label,
  icon,
  disabled,
}) => {
  return (
    <button
      id={inputId}
      data-testid={`${inputId}-field`}
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`py-2 px-2 inline-flex items-center gap-x-1.5 text-xs rounded-lg
                       focus:outline-none focus:bg-gray-50 dark:bg-neutral-800 dark:border-neutral-700
                       dark:text-neutral-300 dark:hover:bg-neutral-700 dark:focus:bg-neutral-700 relative
                       border border-transparent
                       ${disabled ? 'bg-zinc-400 cursor-not-allowed opacity-50' : 'bg-cyan-400 hover:bg-cyan-500 text-white'}
                       dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-neutral-600`}>
      {icon}
      {label}
    </button>
  );
};

export default BlueButton;
